// extracted by mini-css-extract-plugin
export default {"app_button":"style_app_button__oJHqW","app_button__secondary":"style_app_button__secondary__usXbl"};